import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Filter } from 'src/app/models/filter';
import { environment } from 'src/environments/environment';
import { AdvanceReturnType, AdvanceType } from '../@core/constants';
import { Advance } from '../models/advance';
import { AdvanceBalance } from '../models/advance-balance';
import { AdvanceFilter } from '../models/filters/advance-filter';
import { Paging } from '../models/page';
import { AdvanceCreateRequest } from '../models/request/advance-create-request';
import { ResponseModel } from '../models/response-model';
import { WeddingListResponse } from '../models/response/wedding-list-response';
import { WeddingProductResponse } from '../models/response/wedding-product-response';
import { AuthService } from './auth.service';
import { ConfigurationService } from './configuration.service';

@Injectable({
  providedIn: 'root'
})
export class AdvanceService {
  private url = `${environment.url}/advances`;

  constructor(private http: HttpClient, private configurationService: ConfigurationService, private authService: AuthService) { }

  readAdvances(filter: Filter<AdvanceFilter>): Observable<ResponseModel<Paging<Array<Advance>>>> {

    const salesOrgObject = this.configurationService.readSelectedBranchAndSalesOrg().salesOrg;
    const salesOrg = salesOrgObject.code;

    let params = new HttpParams();
    params = params.set('page', filter.page.toString() || '0');
    params = params.set('pageSize', filter.pageSize.toString() || '20');
    params = params.set("salesOrg", salesOrg);

    params = filter.value.customerCode ? params.set("customerCode", filter.value.customerCode) : params;
    params = filter.value.isReturn == true || filter.value.isReturn == false ? params.set("isReturn", String(filter.value.isReturn)) : params;
    params = filter.value.receiptCode ? params.set("receiptCode", filter.value.receiptCode) : params;

    return this.http.get<ResponseModel<Paging<Array<Advance>>>>(this.url, { params });
  }

  requestRefund(advance: Advance, documentType: AdvanceReturnType, advanceType: AdvanceType): Observable<ResponseModel<Advance>> {
    const url = `${environment.url}/advancerefund`;

    const salesBranchObject = this.configurationService.readSelectedBranchAndSalesOrg();
    const salesOrg = salesBranchObject.salesOrg;
    const branch = salesBranchObject.branch;

    const body = {
      customerCode: advance.customerCode,
      salesOrgCode: salesOrg.code,
      amount: advance.totalAmount * -1,
      branchCode: branch.code,
      oldAdvanceCode: advance.code,
      originalAdvanceCode: advance.code,
      advanceType: advanceType,
      documentType: documentType
    };

    return this.http.post<ResponseModel<Advance>>(url, body);
  }

  readAdvancesBalance(customerCode: string): Observable<ResponseModel<AdvanceBalance>> {
    const url = `${environment.url}/advancesbalance`;

    let params = new HttpParams()
      .set("customerCode", customerCode)
      .set("salesOrgCode", this.configurationService.readSelectedBranchAndSalesOrg().salesOrg.code);

    return this.http.get<ResponseModel<AdvanceBalance>>(url, { params });
  }

  createAdvance(request: AdvanceCreateRequest) {
    return this.http.post<ResponseModel<Advance>>(this.url, request);
  }

  readWeddings() {
    return this.http.get<ResponseModel<Array<WeddingListResponse>>>(`${this.url}/wedding`);
  }

  readWeddingProducts(weddingCode: string) {
    return this.http.get<ResponseModel<Array<WeddingProductResponse>>>(`${this.url}/wedding/${weddingCode}/products`);
  }

}
